import { Socket } from "phoenix";

export default (channelName: string, socket: Socket | null) => {
  return socket?.channel(channelName);
};
